import React from "react";

import { baseURL as employeeBaseUrl } from "Dashboard/EmployeeUrls";
import { baseURL as employerBaseUrl } from "Dashboard/EmployerUrls";
import { getEmployeeFormId } from "EmployeeDashboard/selectors";
import { tryGetAccountById, tryGetCompanyPolicyById, tryGetCompanyProfileById, tryGetEmployeePolicyById, tryGetEmployeeFormById } from "EntitiesApi/Selectors";
import { connect } from "react-redux";
import isSquare from "Square/isSquare";
import companyToken from "Utils/companyToken";
import { formatNameFL } from "Utils/formatName";

import { getSiteLogo } from "Common/Selectors";
import ResponsiveTopBar from "Common/TopBar/ResponsiveTopBar";
import TopBarAccountLinks from "Common/TopBar/TopBarAccountLinks";

import type { State } from "EmployerDashboard/store";
import type { CompanyProfile } from "Utils/types";

type DashboardTopBarProps = {
  branding: "samsclub" | "square" | "intuit" | "default";
  partnerLogo?: string;
  accountEmail: string | null | undefined;
  showAdminLink: boolean;
  showSwitchEmployerDashboard: boolean;
  showSwitchEmployeeDashboard: boolean;
  showSwitchCompany: boolean;
  showLogout: boolean;
  showSupport: boolean;
  companyProfile: CompanyProfile | null | undefined;
  employeeName: string | null | undefined;
};

const DashboardTopBarDumb = ({
  branding,
  partnerLogo,
  accountEmail,
  showAdminLink,
  showSwitchEmployerDashboard,
  showSwitchEmployeeDashboard,
  showSwitchCompany,
  showLogout,
  showSupport,
  companyProfile,
  employeeName,
}: DashboardTopBarProps) => {
  const rightContent = [
    <TopBarAccountLinks
      key="accountLinks"
      menuTitle={employeeName || companyProfile?.name || accountEmail}
      showAdminLink={showAdminLink}
      showSwitchEmployerDashboard={showSwitchEmployerDashboard}
      showSwitchEmployeeDashboard={showSwitchEmployeeDashboard}
      showSwitchCompany={showSwitchCompany}
      showUserSettings={false}
      showLogout={showLogout}
      showSupport={showSupport}
    />,
  ];

  return <ResponsiveTopBar branding={branding} rightContent={rightContent} partnerLogo={partnerLogo} />;
};

const mapStateToProps = (state: State) => {
  const account = tryGetAccountById(state, state.accountId);

  // Get Employee Form
  let employeeForm;
  if (account) {
    const employeePolicyId = account.enrolledEmployeePolicy || account.upcomingEmployeePolicy;
    const employeePolicy = tryGetEmployeePolicyById(state, employeePolicyId);
    const employeeFormId = employeePolicy?.employeeForm || getEmployeeFormId(state);
    employeeForm = employeeFormId ? tryGetEmployeeFormById(state, employeeFormId) : null;
  }

  // Get Company Profile
  const companyPolicyId = account?.enrolledCompanyPolicy || account?.upcomingCompanyPolicy;
  const companyPolicy = tryGetCompanyPolicyById(state, companyPolicyId);
  const companyProfile = tryGetCompanyProfileById(state, companyPolicy?.companyProfile);

  const hasEmployeePolicy = (account && !!account.enrolledEmployeePolicy) || (account && !!account.upcomingEmployeePolicy);
  const hasCompanyAccess = account && account.hasCompanyAccess;
  const isEmployerDashboard = window.location.pathname.includes(employerBaseUrl);

  const isEmployeeDashboard = window.location.pathname.includes(employeeBaseUrl);

  const isBenefitsAdmin = companyProfile?.benefitsAdmin || employeeForm?.benefitsAdmin;
  let showSupport = false;
  if (account) {
    // If we don't know if the user is a company or employee, show support
    showSupport = !(companyProfile || employeeForm) || !isBenefitsAdmin;
  }

  return {
    branding: state.siteConfig?.partner_name || "default",
    partnerLogo: getSiteLogo(state),
    accountEmail: account ? account.email : "",
    showAdminLink: account ? account.isAdmin : false,
    showSwitchEmployerDashboard: isEmployeeDashboard && hasCompanyAccess,
    showSwitchEmployeeDashboard: isEmployerDashboard && hasEmployeePolicy,
    showSwitchCompany: account ? companyToken() : false,
    showLogout: account && !isSquare(),
    showSupport,
    employeeName: formatNameFL(employeeForm),
    companyProfile,
  };
};

const DashboardTopBar = connect(mapStateToProps)(DashboardTopBarDumb);

export default DashboardTopBar;
